const INITIAL_STATE = {
	valor: 0,
	lista: [],
	loading: false,
	error: null,
	link: {},
	show_credito: false,
};

// eslint-disable-next-line default-param-last
export function clientSimulador(state = INITIAL_STATE, action) {
	switch (action.type) {
		case '@clientSimulador/REQUEST_SIMULADOR':
			return { ...state, loading: true };

		case '@clientSimulador/SUCCESS_SIMULADOR':
			return {
				...state,
				lista: action.payload.dados.lista,
				valor: action.payload.dados.valor,
				show_credito: action.payload.dados.show_credito,
				loading: false,
				erro: null,
			};

		case '@clientSimulador/FAILURE_SIMULADOR':
			return {
				...state,
				lista: [],
				loading: false,
				show_credito: false,
				erro: action.payload.error,
				valor: 0,
			};

		case '@clientSimulador/REQUEST_LINK':
			return {
				...state,
				link: action.payload.dados,
			};

		default:
			return state;
	}
}
